import { render, staticRenderFns } from "./AdsterraBanner.vue?vue&type=template&id=da83ad32&scoped=true"
import script from "./AdsterraBanner.vue?vue&type=script&lang=js"
export * from "./AdsterraBanner.vue?vue&type=script&lang=js"
import style0 from "./AdsterraBanner.vue?vue&type=style&index=0&id=da83ad32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da83ad32",
  null
  
)

export default component.exports